"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const en_1 = require("./en");
exports.default = {
    en: en_1.default,
};
